<template>
  <div id="app">
    <!-- 首屏视觉 -->
    <section class="hero">
      <div class="hero-overlay"></div>
      
      <!-- 简约导航 -->
      <nav class="main-nav">
       <div class="nav-brand">
        <img src="@/assets/logo2.png" alt="数众新合" class="logo">
        <span class="brand-text">数众新合 - 引领创新广告</span>
       </div>
        <ul class="nav-menu">
          <li v-for="(item, index) in navItems" :key="index">
            <a :href="item.link" class="nav-link" @click="handleNavClick(item)">{{ item.text }}</a>
          </li>
        </ul>
      </nav>

      <!-- 主标语 -->
      <div class="hero-content">
        <h1 class="slogan">引领视频广告创新<br>打造卓越品牌</h1>
        <p class="sub-slogan">从策略到执行的全链路数字营销</p>
      </div>
    </section>

    <!-- 核心优势 -->
    <section class="core-services">
      <div class="service-cards">
        <div class="service-card" v-for="(service, index) in services" :key="index">
          <div class="card-icon">{{ service.icon }}</div>
          <h3 class="card-title">{{ service.title }}</h3>
          <p class="card-desc">{{ service.desc }}</p>
        </div>
      </div>
    </section>

    <section class="about-section" id="about">
  <div class="about-container">
    <!-- 左栏：图文信息 -->
    <div class="about-content">
      <h2 class="section-title">关于数众新合</h2>
      <p class="about-desc">
        四年深耕视频广告战场，我们以智能引擎重塑广告投放格局！依托自研内容生产与精准投放双系统，已为上千家企业品牌打造爆款广告，实现从创意生成到流量触达的全链路提效。通过 AI 算法深度剖析用户画像，结合动态创意优化技术，助您的广告投放 ROI 平均提升 300%，让每一分预算都精准命中目标人群，解锁品效合一的营销新范式！
      </p>
      <div class="milestones">
        <div class="milestone-item" v-for="(item, index) in milestones" :key="index">
          <div class="milestone-value">{{ item.value }}</div>
          <div class="milestone-title">{{ item.title }}</div>
        </div>
      </div>
      <button class="cta-button">了解更多 →</button>
    </div>

    <!-- 右栏：形象展示 -->
    <div class="about-visual">
      <div class="hexagon-container">
        <div class="hexagon hexagon-main">
          <img src="@/assets/szxh.webp" alt="数众新合">
        </div>
        <div class="hexagon hexagon-deco"></div>
      </div>
    </div>
  </div>
</section>

    <!-- 作品展示 -->
    <section class="portfolio" id="media">
  <h2 class="section-title">媒体资源</h2>
  <div class="portfolio-grid">
    <div 
      class="platform-item" 
      v-for="(platform, index) in mediaPlatforms" 
      :key="index"
      :style="{ backgroundColor: platform.bgColor }"
    >
      <img 
        :src="platform.logo" 
        :alt="platform.name" 
        class="platform-logo"
      >
    </div>
  </div>
</section>

<section class="contact-module">
  <div class="contact-wrapper">
    <!-- 原有联系信息 -->
    <div class="contact-info">
      <h3>联系我们</h3>
      <div class="contact-details">
        <div class="detail-item">
          <i class="icon-location"></i>
          <p>北京市朝阳区未来域A座</p>
        </div>
        <div class="detail-item">
          <i class="icon-email"></i>
          <p>contact@shuzhongad.com</p>
        </div>
        <div class="detail-item">
          <i class="icon-phone"></i>
          <p>18511929117</p>
        </div>
      </div>
    </div>

    <!-- 新增联系表单 -->
    <div class="contact-form">
      <h3>或留下您的联系方式,我们的投放顾问会联系您</h3>
      <form class="contact-form">
        <div class="form-group">
          <label for="company">企业名称</label>
          <input type="text" id="company" name="company" required>
        </div>
        <div class="form-group">
          <label for="name">联系人姓名</label>
          <input type="text" id="name" name="name" required>
        </div>
        <div class="form-group">
          <label for="email">联系邮箱</label>
          <input type="email" id="email" name="email" required>
        </div>
        <div class="form-group">
          <label for="phone">联系电话</label>
          <input type="tel" id="phone" name="phone" pattern="[0-9]{3,4}-[0-9]{7,8}" required>
        </div>
        <button type="submit">提交需求</button>
      </form>
    </div>
  </div>
</section>

    <!-- 页脚 -->
   <!-- 备案页脚 -->
<footer class="main-footer">
  <div class="footer-content">
    <div class="copyright">
      © 2025 北京数众新合网络科技有限公司
      <span class="icp">京ICP备2025127792号-1</span>
    </div>
  </div>
</footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      navItems: [
        { text: '首页', link: '#' },
        { text: '媒体资源', link: '#media' },
        { text: '关于数众', link: '#about' },
        { text: '联系我们', link: '#' , scrollToBottom: true}
      ],
      milestones: [
      { value: "4+", title: "行业经验" },
      { value: "1000+", title: "合作客户" },
      { value: "300%", title: "效果提升" },
      { value: "98%", title: "客户满意度" }
    ],
     mediaPlatforms: [
      {
        name: "抖音",
        logo: require('@/assets/douyin3.jpeg'),
        bgColor: '#FFF'
      },
      {
        name: "快手",
        logo: require('@/assets/kuaishou.webp'),
        bgColor: '#FFF'
      },
      {
        name: "腾讯",
        logo: require('@/assets/tengxun.jpg'),
        bgColor: '#FFF'
      },
      {
        name: "今日头条",
        logo: require('@/assets/toutiao.jpg'),
        bgColor: '#FFF'
      },
      {
        name: "小红书",
        logo: require('@/assets/xiaohongshu.jpg'),
        bgColor: '#FFF'
      },
      {
        name: "哔哩哔哩",
        logo: require('@/assets/blbl.jpg'),
        bgColor: '#FFF'
      },
      {
        name: "爱奇艺",
        logo: require('@/assets/aqy.jpg'),
        bgColor: '#FFF'
      },
      {
        name: "谷歌",
        logo: require('@/assets/google.jpg'),
        bgColor: '#FFF'
      }
    ],
      services: [
        {
          icon: '🎯',
          title: '精准定位',
          desc: '基于大数据的消费者洞察与市场定位'
        },
        {
          icon: '🚀',
          title: '传播加速',
          desc: '全渠道媒体投放与效果优化'
        },
        {
          icon: '💡',
          title: '创意孵化',
          desc: '跨平台创意内容生产与运营'
        },
        {
          icon: '📈',
          title: '效果追踪',
          desc: '实时数据监测与ROI分析'
        }
      ]
    }
  },
  methods: {
  handleNavClick(item) {
    if (item.scrollToBottom) {  // 如果点击的是“联系我们”，则滚动到底部
      this.scrollToBottom();
    }
  },
  scrollToBottom() {
    const footer = document.querySelector('.main-footer');
    if (footer) {
      footer.scrollIntoView({ behavior: 'smooth' });
    }
  }
}

}
</script>

<style scoped>
/* 基础样式 */
#app {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  color: #333;
}

/* 首屏视觉 */
.hero {
  height: 100vh;
  position: relative;
  background: linear-gradient(rgba(255, 255, 255, 0.452), rgba(255, 255, 255, 0.178)),
              url('@/assets/szww.jpg');
  background-size: cover;
  background-position: center;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255,255,255,0.4);
}

/* 导航样式 */
.main-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 5%;
  position: fixed;          /* 改为固定定位 */
  top: 0;                   /* 固定在页面顶部 */
  left: 0;
  right: 0;
  z-index: 1000;            /* 提高层级防止被覆盖 */
background-color: hsla(0, 0%, 100%, 0.3);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* 可选阴影，提升质感 */
}


.logo {
  width: 60px;
  height: auto;
}

.nav-menu {
  display: flex;
  gap: 2.5rem;
}

.nav-link {
  color: #2c3e50;
  font-weight: 500;
  text-decoration: none;
  position: relative;
  padding-bottom: 5px;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: #FF6B6B;
  transition: width 0.3s ease;
}

.nav-link:hover::after {
  width: 100%;
}

/* 主标语 */
.hero-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.slogan {
  font-size: 3.5rem;
  font-weight: 700;
  line-height: 1.2;
  color: #2c3e50;
  margin-bottom: 1.5rem;
}

.sub-slogan {
  font-size: 1.2rem;
  color: #7f8c8d;
  letter-spacing: 2px;
}

/* 核心服务 */
.core-services {
  padding: 6rem 5%;
  background: #f9f9f9;
}

.service-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2.5rem;
  max-width: 1200px;
  margin: 0 auto;
}

.service-card {
  background: white;
  padding: 2.5rem;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
  transition: transform 0.3s ease;
}

.service-card:hover {
  transform: translateY(-10px);
}

.card-icon {
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
}

.card-title {
  font-size: 1.4rem;
  color: #2c3e50;
  margin-bottom: 1rem;
}

.card-desc {
  color: #7f8c8d;
  line-height: 1.6;
}

/* 作品展示 */
.portfolio {
  padding: 6rem 5%;
  background: #f9f9f9;
}

.section-title {
  text-align: center;
  font-size: 2.2rem;
  margin-bottom: 3rem;
  color: #2c3e50;
}

.portfolio-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 每行4列 */
  gap: 16px; /* 图片之间的间距，可根据需要调整 */
}

.platform-item {
  width: 100%;
  aspect-ratio: 4 / 3; /* 保持固定比例（例如4:3），自动撑高 */
  overflow: hidden;
  border-radius: 8px;
}

.platform-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 32px rgba(0,0,0,0.12);
}

.platform-logo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.platform-item:hover .platform-logo {
  transform: scale(1.05);
}

/* 平台特色背景处理 */
.platform-item[style*="background-color:#FFF"] {
  border: 1px solid #eee;
}

.hover-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(44, 62, 80, 0.9);
  opacity: 0;
  transition: opacity 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.portfolio-item:hover .hover-mask {
  opacity: 1;
}

.view-button {
  background: none;
  border: 2px solid white;
  color: white;
  padding: 12px 30px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.view-button:hover {
  background: white;
  color: #2c3e50;
}

/* 新增表单样式 */
.contact-form {
  width: 45%;
  background: 	#eef2f8;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 2px 15px rgba(0,0,0,0.1);
}

.contact-form h3 {
  color: #1f1f1f;
  font-size: 15px;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  color: #666;
  font-size: 14px;
}

.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.form-group input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0,123,255,0.25);
}

button[type="submit"] {
  background: #007bff;
  color: white;
  padding: 12px 30px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  font-size: 16px;
  transition: background 0.3s;
}

button[type="submit"]:hover {
  background: #0056b3;
}

/* 页脚 */
.main-footer {
  background: #2c3e50;
  color: white;
  padding: 1rem 5% 1rem;
}

.icp {
  margin-left: 30px;
  color: #999;
}

/* .footer-content {
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto 1rem;
} */

.contact-info h4 {
  font-size: 1.4rem;
  margin-bottom: 1.5rem;
}

.contact-info p {
  color: #090909;
  line-height: 1.8;
}

.footer-logo img {
  width: 80px;
  opacity: 0.8;
}
.nav-brand {
  display: flex; /* 让图片和文字并排 */
  align-items: center; /* 垂直居中 */
}

.brand-text {
  font-size: 18px; /* 文字大小 */
  font-weight: bold; /* 文字加粗 */
  color: #2c3e50; /* 文字颜色 */
}

.copyright {
  text-align: center;
  padding-top: 2rem;
  border-top: 1px solid #34495e;
  color: #bdc3c7;
  font-size: 0.9rem;
}

/* 关于模块样式 */
.about-section {
  padding: 8rem 5%;
  background: linear-gradient(to right bottom, #f9f9f9 50%, #ffffff 50%);
}

.about-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
}

.section-title {
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 2rem;
  position: relative;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -15px;
  left: 0;
  width: 60px;
  height: 3px;
  background: #FF6B6B;
}

.about-desc {
  color: #7f8c8d;
  line-height: 1.8;
  margin-bottom: 2.5rem;
}

.milestones {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  margin-bottom: 3rem;
}

.milestone-item {
  padding: 1.5rem;
  background: rgba(255,107,107,0.1);
  border-radius: 10px;
  text-align: center;
  transition: transform 0.3s ease;
}

.milestone-item:hover {
  transform: translateY(-5px);
}

.milestone-value {
  font-size: 2.2rem;
  color: #FF6B6B;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.milestone-title {
  color: #2c3e50;
  font-size: 0.95rem;
}

.cta-button {
  background: #FF6B6B;
  color: white;
  padding: 1rem 2.5rem;
  border: none;
  border-radius: 30px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.cta-button:hover {
  background: #ff5252;
  letter-spacing: 1px;
}

/* 六边形图形 */
.hexagon-container {
  position: relative;
  width: 400px;
  margin-left: auto;
}

.hexagon {
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
}

.hexagon-main {
  width: 100%;
  height: 450px;
  background: #f0f0f0;
  position: relative;
  z-index: 1;
}

.hexagon-main img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hexagon-deco {
  position: absolute;
  width: 110%;
  height: 110%;
  background: linear-gradient(45deg, #FF6B6B, #ff5252);
  top: -5%;
  left: -5%;
  z-index: 0;
  opacity: 0.1;
}

.contact-module {
  background: #f0f2f5;
  padding: 40px 0;
  border-top: 1px solid #eee;
}

.contact-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  gap: 40px; /* 添加间距 */
  padding: 0 20px;
}

.contact-info h3 {
  color: #333;
  font-size: 24px;
  margin-bottom: 25px;
}

.contact-info {
  width: 45%;
}

.detail-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.detail-item i {
  width: 24px;
  height: 24px;
  margin-right: 15px;
  background-size: contain;
}

.icon-location { background-image: url(@/assets/site.png) }
.icon-email { background-image: url(@/assets/email.png) }
.icon-phone { background-image: url(@/assets/phone.png) }

.contact-logo {
  text-align: center;
}

.contact-logo img {
  width: 150px;
  margin-bottom: 10px;
}


@media (max-width: 768px) {
  .slogan {
    font-size: 2.5rem;
  }

  .nav-menu {
    display: none;
  }

  .service-cards {
    grid-template-columns: 1fr;
  }

  .footer-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .footer-logo {
    margin-top: 2rem;
  }

  .about-container {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .hexagon-container {
    width: 100%;
    max-width: 300px;
    margin: 0 auto;
  }
  
  .milestones {
    grid-template-columns: 1fr;
  }
  .portfolio-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .platform-item {
    padding: 1.5rem;
  }
  
  .platform-logo {
    max-width: 120px;
  }
  
}
</style>